import { InjectedStyledComponent } from '../InjectedStyledComponent';

export default InjectedStyledComponent('ul', 'shared', ['list']);